import { Component } from "@angular/core";

@Component({
  selector: "app-results-overview",
  templateUrl: "./results-overview.component.html"
})
export class ResultsOverviewComponent {
  constructor() {}
}
